import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { getPortDef, sizes } from '@shared/port-v1.0.0'

export type Props = BaseReactProps & {}

import Comp from '../component'

export default {
	module: { static: Comp },
	inNode: {
		inputs: [
			getPortDef({
				name: 'processing',
				displayName: 'Processing',
				group: 'States',
				type: 'boolean',
			}),
			getPortDef({
				name: 'disabled',
				displayName: 'Disabled',
				group: 'States',
				type: 'boolean',
			}),
			getPortDef({
				name: 'label',
				displayName: 'Label',
				group: 'Data',
				type: 'string',
			}),
			getPortDef({
				name: 'color',
				displayName: 'Color',
				group: 'Styles',
				type: 'string',
			}),
			getPortDef({
				name: 'radius',
				displayName: 'Radius',
				group: 'Styles',
				type: sizes,
				default: 'md',
			}),
			getPortDef({
				name: 'withBorder',
				displayName: 'With border',
				group: 'Styles',
				type: 'boolean',
			}),
			getPortDef({
				name: 'position',
				displayName: 'Position',
				group: 'Layout',
				type: [
					{ value: 'top-start', label: 'top-start' },
					{ value: 'top-center', label: 'top-center' },
					{ value: 'top-end', label: 'top-end' },
					{ value: 'middle-start', label: 'middle-start' },
					{ value: 'middle-center', label: 'middle-center' },
					{ value: 'middle-end', label: 'middle-end' },
					{ value: 'bottom-start', label: 'bottom-start' },
					{ value: 'bottom-center', label: 'bottom-center' },
					{ value: 'bottom-end', label: 'bottom-end' },
				],
                default: 'top-end',
			}),
			getPortDef({
				name: 'offset',
				displayName: 'Offset',
				group: 'Layout',
				type: 'number',
				default: 0,
			}),
			getPortDef({
				name: 'size',
				displayName: 'Size',
				group: 'Dimensions',
				type: 'string',
				default: '10',
				tooltip: '1vh, 20%, 100px, 100, auto'
			}),
		],
		outputs: [],
	},
} satisfies ReactNodeDef
